import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import { ReactNode, useState } from 'react'

interface AccordianProps {
  title: string
  openByDefault?: boolean
  children: ReactNode
  className?: string
}

const Accordian = ({ title, openByDefault = false, children, className = '' }: AccordianProps) => {
  const [isOpen, setIsOpen] = useState(openByDefault)

  return (
    <div className={className}>
      <span
        className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-1 tw-px-4 tw-py-2"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <h4 className="tw-m-0 tw-pr-4 tw-text-base">{title}</h4>
        {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </span>
      {isOpen && <div>{children}</div>}
    </div>
  )
}

export default Accordian
